// Helper to fetch data from CMS public endpoints relative to the site's own origin

const API_BASE = '/_api/public';

/**
 * Fetch a CMS collection array
 */
export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/content/${collectionName}`);
    if (!res.ok) {
      console.warn(`Failed to fetch CMS collection ${collectionName}: ${res.status}`);
      return [];
    }
    const data = await res.json();
    if (Array.isArray(data)) {
      return data;
    }
    if (data && Array.isArray(data.items)) {
      return data.items;
    }
    return [];
  } catch (err) {
    console.error(`Error fetching CMS collection ${collectionName}:`, err);
    return [];
  }
}

/**
 * Fetch the first item from a single-entry collection (e.g. kontakt_oplysninger, forside, om_lenea)
 */
export async function fetchSingleItem(collectionName) {
  try {
    const items = await fetchCollection(collectionName);
    return items && items.length > 0 ? items[0] : null;
  } catch (err) {
    console.error(`Error fetching single item from ${collectionName}:`, err);
    return null;
  }
}

/**
 * Normalize slug string for resilient comparisons
 */
export function normalizeSlug(str) {
  if (!str) return '';
  return String(str)
    .toLowerCase()
    .trim()
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'o')
    .replace(/oe/g, 'o')
    .replace(/å/g, 'aa')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Fetch an item from a collection matching a slug or field
 */
export async function fetchItemBySlug(collectionName, slug, fieldName = 'forlob_slug') {
  try {
    const items = await fetchCollection(collectionName);
    const target = normalizeSlug(slug);
    return (
      items.find((item) => {
        const val = item[fieldName] || item.slug || item.slug?.da;
        if (val === slug) return true;
        if (val && normalizeSlug(val) === target) return true;
        if (item.id === slug) return true;
        return false;
      }) || null
    );
  } catch (err) {
    console.error(`Error fetching item by slug ${slug} from ${collectionName}:`, err);
    return null;
  }
}
